import React, { useState } from 'react';
import './ndoeUi.css';
import { useIsDesktop } from './useMediaQuery';

/**
 * NdoeFilterBar — barre de filtres.
 *  - Desktop : filtres horizontaux toujours visibles.
 *  - Mobile  : repliée derrière un bouton "Filtres" (dépliable).
 *
 * Props :
 *  - children      : les champs de filtre (chacun idéalement dans un .ndoe-filter-bar__field)
 *  - defaultOpen   : ouverte par défaut sur mobile (défaut false)
 *  - toggleLabel   : libellé du bouton mobile (défaut 'Filtres')
 *  - activeCount   : nombre de filtres actifs (badge sur le bouton, optionnel)
 *  - className
 */
export default function NdoeFilterBar({
  children,
  defaultOpen = false,
  toggleLabel = 'Filtres',
  activeCount = 0,
  className = '',
}) {
  const isDesktop = useIsDesktop();
  const [open, setOpen] = useState(defaultOpen);
  const collapsed = !isDesktop && !open;

  return (
    <>
      {!isDesktop ? (
        <button
          type="button"
          className="ndoe-btn ndoe-btn--secondary ndoe-btn--sm ndoe-filter-toggle"
          style={{ marginBottom: 12 }}
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          {toggleLabel}
          {activeCount > 0 ? (
            <span className="ndoe-badge ndoe-badge--gold" style={{ marginLeft: 6 }}>
              {activeCount}
            </span>
          ) : null}
        </button>
      ) : null}

      <div className={`ndoe-filter-bar ${collapsed ? 'is-collapsed' : ''} ${className}`}>
        {children}
      </div>
    </>
  );
}
